export default "__VITE_ASSET__RVDVfJ8c__"